import { Component } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(private TranslationService: TranslationService) {
    this.TranslationService.getLanguages().subscribe((res: any) => {
      this.TranslationService.setLanguages(res.data);
      this.TranslationService.getTranslations(res.data[0]._id);
    });
  }
  title = 'Lunge';
}
